'use client'

import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface InstructionModalProps {
    show: boolean;
    onHide: () => void;
}

const INSTRUCTION_TEXT = `Опишите наилучшие результаты, которые возможны для данной части в выбранный вами период`;

const INSTRUCTION_LIST = [
    {
        title: 'Как ставить цели:', items: [
            'Разрешить себе то, что описано в цели',
            'Цель должна быть записана со всеми важными деталями',
            'Цель должна быть высокой. Ставьте цели, которые реально значимые и большие. У нас в "Банке" лежат наши деньги. Мы не знаем сколько. Взять мы можем не больше, чем запросим',
            'Цель должна быть в настоящем времени. Подсознание работает только здесь и сейчас. "Я сегодня и каждый день пробегаю 5 км утром с радостью"',
            'Цель должна быть в позитивном ключе и не содержать отрицаний. Вместо "Я не курю" пишем "Я веду здоровый образ жизни и имею только здоровые привычки"',
            'В постановке целей нет мелочей. Все, что явно не указано в цели может быть реализовано как угодно',
            'Цели нужно ставить только относительно себя'
        ]
    },
    {
        title: 'Признаки качественно поставленной цели:', items: [
            'Сильное желание осуществить цель',
            'Ответьте на вопрос: "Стану ли я лучше и гармоничнее, осуществив эту цель?"',
            'Вы готовы развиваться и приносить людям пользу ради осуществления цели. Чтобы получить то, чего нет сейчас, нужно делать то, что раньше не делал или менять качество действий'
        ]
    },
    { title: 'Скорость достижения целей растет по мере роста ваших качеств. Достижение целей это развитие ваших качеств' },
    {
        title: 'Замечания по движению к целям:', items: [
            'Визуализировать цель и ее достижение. Представлять план',
            'Избегать эмоций счастья только от визуализации, так как это препятствует',
            'Должно быть желание осуществлять цель. Желание дает энергию к действию. Если нет желания, то энергия действовать будет браться например из здоровья. Человек болеет если осуществляет не свою цель',
            'Не нужно стремиться достигать цель любой ценой. Лучше всего за счёт своего развития',
            'При постановке целей на день записывать в ежедневнике не только событие но и результат',
            'Цели на день нужно писать вечером предыдущего'
        ]
    },
    {
        title: 'Защита от не корректно поставленных целей:', items: [
            'Пусть это произойдет, если это принесет мне счастье',
            'Пусть это произойдет, если это принесет благо людям',
            'Пусть это или нечто лучшее гармонично войдет в мою жизнь, неся высшее благо всем, кого это касается'
        ]
    }
];

export function InstructionModal({ show, onHide }: InstructionModalProps) {
    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Как ставить цели</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="lead">{INSTRUCTION_TEXT}</p>
                {INSTRUCTION_LIST.map((section, index) => (
                    <div key={index} className="mb-3">
                        <strong>{section.title}</strong>
                        {section.items && section.items.length > 0 && (
                            <ul className="mb-0 mt-2">
                                {section.items.map((item, itemIndex) => (
                                    <li key={itemIndex}>{item}</li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onHide}>
                    Понятно
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
